import { TierFeatureInTier } from '@/pages/unauthenticated/pricing/components/tier-comparisons/shared/tier.feature-in-tier';
import {
  PlatformFeature,
  PricingTier,
} from '@/pages/unauthenticated/pricing/components/types';

interface TierFeatureRowProps {
  feature: PlatformFeature;
  tiers: PricingTier[];
  showBorder: boolean;
}

export const TierFeatureRow = ({
  feature,
  tiers,
  showBorder,
}: TierFeatureRowProps) => (
  <tr>
    <th
      scope="row"
      className="w-1/4 py-3 pr-4 text-left text-sm font-normal leading-6"
    >
      {feature.name}
      {showBorder && (
        <div className="absolute inset-x-8 mt-3 h-px bg-halfmast-1000" />
      )}
    </th>
    {tiers.map((tier) => (
      <td
        key={tier.activeTier}
        className="relative w-1/4 px-4 py-0 text-center"
      >
        <span className="relative h-full w-full py-3">
          <TierFeatureInTier feature={feature} tier={tier} />
          <span className="sr-only">
            {feature.tiers[tier.name] ? 'Yes' : 'No'}
          </span>
        </span>
      </td>
    ))}
  </tr>
);
